import { ClearCMSTokenAction } from "../actions/ClearCMSToken";
import { AppState } from "../state";

export function clearCMSToken(state: AppState, action: ClearCMSTokenAction): AppState {
    const { appId } = action.payload;

    return {
        ...state,
        tokens: {
            ...state.tokens,
            [appId]: {
                currentTokens: state.tokens[appId].currentTokens
            }
        }
    };
}
